// 2026-10-18：仅在提示/确认框展示时翻译本地词典文案，不改API响应、业务状态或提交字段。
import { message, notification, Modal } from 'ant-design-vue'
import { translateUi } from './display'

function translated(value: any): any {
  if (typeof value === 'string') return translateUi(value)
  if (!value || typeof value !== 'object' || value.__v_isVNode) return value
  const copy = { ...value }
  for (const key of ['title', 'content', 'message', 'description', 'okText', 'cancelText']) {
    if (typeof copy[key] === 'string') copy[key] = translateUi(copy[key])
  }
  return copy
}
export function installLocalizedFeedback(): void {
  for (const [target, methods] of [
    [message, ['success', 'error', 'info', 'warning', 'warn', 'loading', 'open']],
    [notification, ['success', 'error', 'info', 'warning', 'warn', 'open']],
    [Modal, ['success', 'error', 'info', 'warning', 'warn', 'confirm']]
  ] as [any, string[]][]) {
    for (const method of methods) {
      const original = target[method]
      if (typeof original !== 'function') continue
      target[method] = function (value: any, ...args: any[]) { return original.call(target, translated(value), ...args) }
    }
  }
}
